import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { LaughChallengeBanner } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function LaughChallenge() {
  return (
    <>
      <SEO
        title="Try Not To Laugh Challenge - Play with Strangers | Talkvee"
        description="Take the Try Not To Laugh challenge online! Match with strangers in a random video chat and see who laughs first. Fast, fun, and 100% free."
        pathname="/laugh-challenge-chat"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Laugh Challenge", "item": "https://talkvee.com/laugh-challenge-chat" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <LaughChallengeBanner />
        
        <section className="landing-hero">
          <h1 className="landing-title">Try Not To Laugh Challenge Online</h1>
          <p className="landing-subtitle">
            Can you keep a straight face? Talkvee's 'Laugh Mode' uses advanced face-tracking to detect when you or your partner smiles. It is the most addictive way to meet new people.
          </p>
          <Link to="/" className="tv-cta">🚀 Start the Laugh Challenge</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>How It Works</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#fef3c7', padding: '20px', borderRadius: '12px', border: '1px solid #fde68a'}}>
              <h4 style={{margin: '0 0 10px', color: '#92400e', fontSize: '1.1rem'}}>🤖 AI Detection</h4>
              <p style={{margin: 0, color: '#78350f', lineHeight: '1.6'}}>
                Our AI monitors your expressions. If you smile or laugh, the other person gets the point!
              </p>
            </div>
            <div style={{background: '#fef3c7', padding: '20px', borderRadius: '12px', border: '1px solid #fde68a'}}>
              <h4 style={{margin: '0 0 10px', color: '#92400e', fontSize: '1.1rem'}}>📹 Share the Fun</h4>
              <p style={{margin: 0, color: '#78350f', lineHeight: '1.6'}}>
                Record your funniest reactions and share them as VeeClips to show the world your winning streak.
              </p>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "How do I play the Try Not To Laugh challenge?",
              a: "Connect with a partner and click the 'Laugh Mode' icon. Once you both accept, the AI will start tracking your faces for any signs of a smile!"
            },
            {
              q: "Is it safe to play?",
              a: "Yes. All games are conducted in our moderated environment. You can report any inappropriate behavior immediately."
            },
            {
              q: "Does it work on mobile?",
              a: "Absolutely. Talkvee's AI face-tracking is optimized to work smoothly in both mobile and desktop browsers."
            }
          ]}
        />
      </div>
    </>
  );
}